import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmptyBox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 149,
	height: 95,
	viewBox: "0 0 149 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M71.037 12.4815L22.8148 23.963M71.037 12.4815L82.5185 1L133.037 12.4815L126.148 18.2222M71.037 12.4815L64.1481 3.2963L11.3333 13.6296L22.8148 23.963M71.037 12.4815L111.222 22.1501M22.8148 23.963L71.037 37.7407M22.8148 23.963L1 20.5185L22.8148 27.4807M71.037 37.7407V94M71.037 37.7407L119.259 23.963M71.037 37.7407H54.963L22.8148 27.4807M71.037 37.7407L82.5185 29.7037L111.222 22.1501M71.037 94L22.8148 72.1852V27.4807M71.037 94L119.259 72.1852V23.963M119.259 23.963L126.148 18.2222M126.148 18.2222L111.222 22.1501",
		stroke: "#ACC5DD"
	})
});
export default SvgEmptyBox;
